import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Box as material_Box } from "@mui/material";
const Box_Box = /*#__PURE__*/ forwardRef(function({ ...props }, ref) {
    return /*#__PURE__*/ jsx(material_Box, {
        ...props,
        ref: ref
    });
});
export { Box_Box as Box };

//# sourceMappingURL=Box.js.map